import React from 'react'
import ArrangementLab from './pages/Studio'

// Render the arrangementLab app
function App() {
  return <ArrangementLab />
}

export default App
